import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroller til toppen ved rutens skift, eller til #ankeret hvis der er et, og
// sender samtidig GA page_view.
const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname + search,
        page_location: window.location.href,
      });
    }
    // Et #anker skal vinde over "scroll til top", ellers lander et link til
    // kontaktformularen øverst på siden i stedet for ved formularen. Springet er
    // bevidst uden animation: ved et sideskift skal man lande ved målet med det samme.
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      const spring = (el) => el.scrollIntoView({ behavior: "auto", block: "start" });
      const el = document.getElementById(id);
      if (el) {
        spring(el);
        return;
      }
      // Målet kan ligge i en rutegren, der først lige er hentet.
      const t = setTimeout(() => {
        const sen = document.getElementById(id);
        if (sen) spring(sen);
      }, 300);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, search, hash]);
  return null;
};

export default ScrollToTop;
